import { createTheme } from '@mui/material/styles';
import { color, font, radius } from './tokens';

/**
 * MUI theme mirrors the design tokens in ./tokens.ts so `sx` props and
 * styled-components stay visually identical.
 * Primary = sand, Secondary = forest (unchanged brand colours).
 */
const theme = createTheme({
  palette: {
    primary: {
      main: color.sand,
      light: color.sandLight,
      dark: color.sandDeep,
      contrastText: color.ink,
    },
    secondary: {
      main: color.forest,
      light: color.forestSoft,
      dark: color.forestDeep,
      contrastText: '#ffffff',
    },
    background: {
      default: color.cream,
      paper: color.paper,
    },
    text: {
      primary: color.ink,
      secondary: color.inkSoft,
    },
    success: { main: color.success },
    warning: { main: color.warning },
    error: { main: color.danger },
  },
  typography: {
    fontFamily: font.body,
    h1: { fontFamily: font.display, fontWeight: 600, lineHeight: 1.05 },
    h2: { fontFamily: font.display, fontWeight: 600, lineHeight: 1.1 },
    h3: { fontFamily: font.display, fontWeight: 600, lineHeight: 1.15 },
    h4: { fontFamily: font.display, fontWeight: 600 },
    h5: { fontFamily: font.display, fontWeight: 600 },
    h6: { fontFamily: font.body, fontWeight: 600 },
    body1: { lineHeight: 1.7 },
    body2: { lineHeight: 1.65 },
    button: { fontWeight: 500, textTransform: 'none', letterSpacing: '0.04em' },
  },
  shape: {
    borderRadius: parseInt(radius.md, 10),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: radius.pill,
          transition: 'transform 320ms cubic-bezier(0.34, 1.4, 0.64, 1), box-shadow 320ms ease',
        },
        containedPrimary: {
          backgroundColor: color.sand,
          color: color.ink,
          '&:hover': { backgroundColor: color.sandDeep },
        },
        containedSecondary: {
          backgroundColor: color.forest,
          '&:hover': { backgroundColor: color.forestDeep },
        },
        outlinedSecondary: {
          borderColor: 'rgba(74, 112, 97, 0.4)',
          color: color.forest,
          '&:hover': { borderColor: color.forest, backgroundColor: 'rgba(74, 112, 97, 0.06)' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: { boxShadow: '0 12px 34px rgba(58, 48, 38, 0.07)' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: radius.lg },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' },
    },
  },
});

export default theme;
